import Vue from 'vue'
import Vuex from 'vuex'

import customers from './store/Customers'
import orders from './store/Orders'
import productLists from './store/ProductLists'
import products from './store/Products'
import users from './store/Users'

Vue.use(Vuex)

const options = {
  modules: {
    customers,
    orders,
    productLists,
    products,
    users
  }
}

export default new Vuex.Store(options)
export { options }



// WEBPACK FOOTER //
// ./src/Store.js